import React, { useEffect, useState } from 'react'

export default function CountUpStat({
  target,
  prefix = '',
  suffix = '',
  decimals = 0,
  duration = 1500,
  label,
  valueClassName = 'text-2xl font-bold text-neon-300 sm:text-3xl',
  labelClassName = 'mt-1 text-xs text-white/60 sm:text-sm',
}) {
  const [value, setValue] = useState(0)

  useEffect(() => {
    let raf
    const start = performance.now()

    const animate = (now) => {
      const progress = Math.min((now - start) / duration, 1)
      setValue(target * progress)
      if (progress < 1) raf = requestAnimationFrame(animate)
    }

    raf = requestAnimationFrame(animate)
    return () => cancelAnimationFrame(raf)
  }, [target, duration])

  const formatted =
    decimals > 0
      ? value.toFixed(decimals)
      : Math.round(value).toLocaleString('es-MX')

  return (
    <div>
      <dt className={valueClassName}>
        {prefix}
        {formatted}
        {suffix}
      </dt>
      <dd className={labelClassName}>{label}</dd>
    </div>
  )
}
